<script lang="ts">
import WmtsLayer from './wmts-layer.vue'
import WmsLayer from './wms-layer.vue'
import XyzLayer from './xyz-layer.vue'

export default {
    name: 'DkOlLayers',
    components: { WmtsLayer, WmsLayer, XyzLayer },
    props: {
        layers: { type: Array, required: true },
    },
    data() {
        return {
        }
    },
}
</script>

<template>
    <template v-for="layer in layers" :key="layer.k">
        <XyzLayer v-if="layer.type === 'xyz'" :layer />
        <WmsLayer v-if="layer.type === 'WMS'" :layer />
        <WmtsLayer v-if="layer.type === 'WMTS'" :layer />
    </template>
</template>

<style scoped>

</style>
